var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 9.45V2.025L19.0312 9.45M2.625 0C1.16813 0 0 1.2015 0 2.7V24.3C0 25.0161 0.276562 25.7028 0.768845 26.2092C1.26113 26.7155 1.92881 27 2.625 27H18.375C19.0712 27 19.7389 26.7155 20.2312 26.2092C20.7234 25.7028 21 25.0161 21 24.3V8.1L13.125 0H2.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile3);
export default __webpack_public_path__ + "static/media/file3.ff0c21d8a395fd4ca798c9176cc110b7.svg";
export { ForwardRef as ReactComponent };